// TODO rename file to jsx file and move into components->globalComponents
import React, { Component } from 'react';
import '@fullcalendar/core/main.css';
import '@fullcalendar/daygrid/main.css';
import '@fullcalendar/timegrid/main.css';
import 'primereact/resources/primereact.min.css';
import 'primeflex/primeflex.css';
import './styles/app.css';
import classNames from 'classnames';
import DomHandler from 'primereact/components/utils/DomHandler';
import { ScrollPanel } from 'primereact/components/scrollpanel/ScrollPanel';
import { withRouter } from 'react-router-dom';
import AppTopbar from './components/application/AppTopbar';
import AppMenu from './components/application/AppMenu';
import AppBreadcrumb from './components/application/AppBreadcrumb';
import UserAdmin from './views/UserAdmin';
import UserData from './views/UserData';
import ImportPage from './views/ImportPage';
import ImportList from './views/ImportList';
import MetaData from './views/MetaData';
import ReferenceData from './views/ReferenceData';
import ReleaseObjects from './views/ReleaseObjects';
import Dashboard from './views/Dashboard';
import ChangePassword from './views/ChangePassword';
import Statistics from './views/Statistics';
import { StatisticsNamesNavigator } from './utils/statisticsUtils';
import MessageService from './service/MessageService';
import NodeService from './service/NodeService'; // perhaps later
// import { MultiLanguage } from './utils/MultiLanguage';
import './ripple';
// import EditUser from './components/deprecatedEditUser';
import { ProtectedRoute } from './components/application/ProtectedRoute';
import Datastock from './views/Datastock';
import RequestData from './views/RequestData';
import Evaluation from './views/Evaluation';
import TablesSaved from './views/TablesSaved';
import TablesStandard from './views/TablesStandard';
import StandardFolders from './views/StandardFolders';
import KeyFigure from './views/KeyFigure';
import { formTypes } from './utils/userFormTypes';
import KeyFigureAdmin from './views/KeyFigureAdmin';
import { returnUserRights } from './utils/roleUtils';

class App extends Component {
  constructor(props) {
    super(props);
    // const userRights = returnUserRights();
    // const { group } = userRights;
    // const isMinistery = group.includes('Ministerium');
    const isAdmin = sessionStorage.getItem('role') === 'GROUP_ADMIN';
    this.state = {
      activeTopbarItem: null,
      layoutMode: 'static',
      mobileMenuActive: null,
      topbarMenuActive: null,
      menuActive: false,
      isAdmin,
      isSuperSubjAdmin: sessionStorage.getItem('role') === 'SUPER_SUBJECT_ADMIN',
      isSysAdmin: sessionStorage.getItem('role') === 'SYSTEM_ADMIN',
      isStBA: sessionStorage.getItem('group') === 'StBA',
      userName:
        sessionStorage.getItem('firstName') !== 'null'
          ? `${sessionStorage.getItem('firstName')
          } ${sessionStorage.getItem('lastName')}`
          : 'Benutzerdaten',
      availableStatistics: [],
    };

    this.onTopbarItemClick = this.onTopbarItemClick.bind(this);
    this.onMenuButtonClick = this.onMenuButtonClick.bind(this);
    this.onTopbarMobileMenuButtonClick = this.onTopbarMobileMenuButtonClick.bind(
      this,
    );
    // this.onWrapperClick = this.onWrapperClick.bind(this);
    this.onSidebarMouseEnter = this.onSidebarMouseEnter.bind(this);
    this.onSidebarMouseLeave = this.onSidebarMouseLeave.bind(this);
    this.onToggleMenuClick = this.onToggleMenuClick.bind(this);
    this.onSidebarClick = this.onSidebarClick.bind(this);
    this.onRootMenuItemClick = this.onRootMenuItemClick.bind(this);
    this.onMenuItemClick = this.onMenuItemClick.bind(this);
    this.messageService = new MessageService();
    // this.multiLanguage = new MultiLanguage();
    this.nodeservice = new NodeService();
    this.createMenu();
  }

  // TODO following method is not really necessary?!

  /* onWrapperClick() {
    console.log("tedast")
    const { mobileMenuActive } = this.state;
    if (
      !this.menuClick
      && !this.menuButtonClick
      && mobileMenuActive
    ) {
      this.setState({ mobileMenuActive: false });
    }

    if (!this.topbarMenuClick && !this.topbarMenuButtonClick) {
      this.setState({
        activeTopbarItem: null,
        topbarMenuActive: false,
      });
    }

    if (!this.menuClick) {
      if (this.isHorizontal() || this.isOverlay()) {
        this.setState({
          menuActive: false,
        });
      }
    }

    this.menuClick = false;
    this.menuButtonClick = false;
    this.topbarMenuClick = false;
    this.topbarMenuButtonClick = false;
    console.log("test");
  } */

  componentDidMount = async () => {
    const { isAdmin, isSuperSubjAdmin, isStBA } = this.state;
    const statisticsList = await this.messageService.postStatisticDirectory();
    const availableStatistics = [];
    for (let i = 0; i < statisticsList.length; i += 1) {
      availableStatistics[i] = { label: StatisticsNamesNavigator[statisticsList[i].name], icon: 'assessment', to: `/tablesstandard&${statisticsList[i].name}` };
    }
    this.setState({ availableStatistics });
    if (isAdmin && isStBA) {
      availableStatistics.push({ label: 'Standardordner', icon: 'folder', to: '/standardfolders' });
    }
  }

  onTopbarItemClick(event) {
    const { activeTopbarItem } = this.state;
    this.topbarMenuClick = true;
    if (activeTopbarItem === event.item) this.setState({ activeTopbarItem: null });
    else this.setState({ activeTopbarItem: event.item });
    event.originalEvent.preventDefault();
  }

  onMenuButtonClick(event) {
    this.menuButtonClick = true;
    const { mobileMenuActive } = this.state;

    if (this.isMobile()) {
      this.setState({ mobileMenuActive: !mobileMenuActive });
    }

    event.preventDefault();
  }

  onTopbarMobileMenuButtonClick(event) {
    this.topbarMenuButtonClick = true;
    const { topbarMenuActive } = this.state;

    this.setState({ topbarMenuActive: !topbarMenuActive });
    event.preventDefault();
  }

  // eslint-disable-next-line no-unused-vars
  onToggleMenuClick(event) {
    const { layoutMode } = this.state;
    this.setState({
      layoutMode: layoutMode !== 'static' ? 'static' : 'overlay',
    });
  }

  // eslint-disable-next-line no-unused-vars
  onSidebarClick(event) {
    this.menuClick = true;
  }

  // eslint-disable-next-line no-unused-vars
  onSidebarMouseEnter(event) {
    if (this.sidebarTimeout) {
      clearTimeout(this.sidebarTimeout);
    }
    DomHandler.addClass(this.sidebar, 'layout-sidebar-active');
  }

  // eslint-disable-next-line no-unused-vars
  onSidebarMouseLeave(event) {
    this.sidebarTimeout = setTimeout(() => {
      DomHandler.removeClass(this.sidebar, 'layout-sidebar-active');
    }, 250);
  }

  // eslint-disable-next-line no-unused-vars
  onRootMenuItemClick(event) {
    const { menuActive } = this.state;
    this.setState({
      menuActive: !menuActive,
    });
  }

  onMenuItemClick(event) {
    if (!event.item.items && this.isHorizontal()) {
      this.setState({
        menuActive: false,
      });
    }
  }

  updateBreadcrumbNames(firstName, lastName) {
    this.setState(
      {
        userName: `${firstName} ${lastName}`,
      },
    );
  }

  async returnStandardItems() {
    // this.messageService = new MessageService();
    // this.multiLanguage = new MultiLanguage();
    const statisticsList = await this.messageService.postStatisticDirectory();
    const standardItems = [];
    for (let i = 0; i < statisticsList.length; i += 1) {
      standardItems[i] = { label: this.multiLanguage.returnInLanguage(statisticsList[i], 'de'), icon: 'assessment', to: `/tablesstandard&${statisticsList[i].name}` };
    }
  }

  async createMenu() {
    const {
      isAdmin, isSuperSubjAdmin, isSysAdmin, isStBA,
    } = this.state;
    // console.log('ADMIN#', isAdmin, isSysAdmin, isStBA);
    const standardItems = [];
    /*
      { label: 'Studierende', icon: 'assessment', to: '/tablesstandard&21311' },
      { label: 'Prüfungen', icon: 'assessment', to: '/tablesstandard&21321' },
      { label: 'Hochschulpersonal', icon: 'assessment', to: '/tablesstandard&21341' },
      { label: 'Habilitationen', icon: 'assessment', to: '/tablesstandard&21351' },
      { label: 'Promovierende', icon: 'assessment', to: '/tablesstandard&21352' },
      { label: 'Hochschulfinanzen', icon: 'assessment', to: '/tablesstandard&21371' },
    ];
    if (isAdmin && isStBA) {
      standardItems.push({ label: 'Standardordner', icon: 'folder', to: '/standardfolders' });
    }
    */

    // TODO could we seperate this menu in different file please:
    // this.menu = await this.nodeservice.getTreeTableNodes('../assets/appmenu.json');

    this.menu = [
      { label: 'Startseite', icon: 'home', to: '/' },
      {
        label: 'Metadaten',
        icon: 'assignment_late',
        items: [
          { label: 'Statistiken', icon: 'assignment', to: '/metadata&statistic' },
          { label: 'Kennzahlen', icon: 'assignment' }, // , to: '/metadata&key'},
        ],
      },
      { label: 'Auswertungen', icon: 'apps', to: '/evaluation' },
      {
        label: 'Standardtabellen',
        icon: 'picture_in_picture',
        items: standardItems,
      },
      {
        label: 'Kennzahlen',
        icon: 'format_list_numbered',
        items: [
          { label: 'Nicht-monetär', icon: 'panorama_fish_eye', to: '/keyfigures&nonmonetary' },
          { label: 'Monetär', icon: 'euro_symbol', to: '/keyfigures&monetary' },
        ],
      },
      {
        label: 'Ordnerverzeichnis',
        icon: 'folder',
        items: [
          { label: 'Persönlicher Ordner', icon: 'folder_special', to: '/tablessaved&personal' },
          { label: 'Gruppenordner', icon: 'folder_shared', to: '/tablessaved&shared' },
          { label: 'Amtsinterner Ordner', icon: 'folder', to: '/tablessaved&transfer' },
          { label: 'Öffentlicher Ordner', icon: 'folder_open', to: '/tablessaved&free' },
        ],
      },
      { label: 'Kennwort ändern', icon: 'vpn_key', to: '/changepassword' },
      { label: 'Meine Benutzerdaten', icon: 'account_circle', to: '/userdata' },
      // { label: "Beispiel", icon: "border_all", to: "/example" }
    ];
    const adminEntries = [
      { label: 'Benutzerverwaltung', icon: 'account_box', to: '/useradmin' },
      { label: 'Freigabe von Objekten', icon: 'assignment_turned_in', to: '/releaseobjects' },
      { label: 'Pflege Kennzahlen', icon: 'grade', to: '/keyfigureadmin' },
      { label: 'Referenzmetadaten', icon: 'link', to: '/referencedata' },
      { label: 'Import', icon: 'file_upload', to: '/importpage' },
      { label: 'Datenbestände', icon: 'blur_linear', to: '/datastock' },
      { label: 'Datenabfrage', icon: 'personal_video', to: '/requestdata' },
      { label: 'Übersicht Aufträge', icon: 'list_bulleted', to: '/importlist' },
    ];
    if (isSuperSubjAdmin) adminEntries.splice(0, 1);
    if (isSysAdmin || (isAdmin && isStBA) || isSuperSubjAdmin) {
      // TODO could we seperate this menu additionals in different file please
      this.menu.push({
        label: 'Fachadministrator',
        icon: 'settings',
        items: adminEntries,
      });
    } else {
      this.menu.push(
        { label: 'Datenbestände', icon: 'blur_linear', to: '/datastock' },
        { label: 'Übersicht Aufträge', icon: 'list_bulleted', to: '/importlist' },
      );
    }
    if (isAdmin && !isStBA) {
      // TODO could we seperate this menu additionals in different file please
      this.menu.push({
        label: 'Fachadministrator',
        icon: 'settings',
        items: [
          { label: 'Benutzerverwaltung', icon: 'account_box', to: '/useradmin' },
          { label: 'Freigabe von Objekten', icon: 'assignment_turned_in', to: '/releaseobjects' },
        ],
      });
    }
  }

  // eslint-disable-next-line class-methods-use-this
  isMobile() {
    return window.innerWidth <= 1024;
  }

  // eslint-disable-next-line class-methods-use-this
  isDesktop() {
    return window.innerWidth > 1024;
  }

  isOverlay() {
    const { layoutMode } = this.state;
    return layoutMode === 'overlay';
  }

  isHorizontal() {
    const { layoutMode } = this.state;
    return layoutMode === 'horizontal';
  }

  render() {
    const {
      layoutMode,
      menuActive,
      mobileMenuActive,
      darkMenu,
      activeTopbarItem,
      topbarMenuActive,
      userName,
      availableStatistics,
    } = this.state;
    this.menu[3].items = availableStatistics;
    const wrapperClass = classNames('layout-wrapper', {
      'layout-wrapper-static': layoutMode === 'static',
      'layout-wrapper-active': mobileMenuActive,
      'layout-menu-horizontal': layoutMode === 'horizontal',
    });
    const sidebarClassName = classNames('layout-sidebar', {
      'layout-sidebar-dark': darkMenu,
    });
    const AppBreadCrumbWithRouter = withRouter(AppBreadcrumb);

    return (
      // TODO onWrapperClickMethod can be removed
      <div className={wrapperClass}>
        {' '}
        <div
          ref={(el) => { (this.sidebar = el); }}
          className={sidebarClassName}
          /* onClick={this.onSidebarClick} */ // onClick can be removed
          onMouseEnter={this.onSidebarMouseEnter}
          onMouseLeave={this.onSidebarMouseLeave}
          style={{ zIndex: 998 }}
        >
          <div
            className="sidebar-logo"
            style={{ backgroundColor: '#f0f0f0', height: '92px' }}
          >
            <button type="button" style={{ textAlign: 'center' }} className="p-link">
              <img
                width={150}
                alt="DESTATIS"
                id="logo"
                src={`${process.env.PUBLIC_URL}/assets/layout/images/logo.svg`}
              />
              <div>Auswertungsdatenbank</div>
              <div>
                Hochschulstatistik
              </div>
            </button>
            <button
              type="button"
              className="p-link sidebar-anchor"
              id="togglemenu"
              title="Menü verkleinern/erweitern"
              onClick={this.onToggleMenuClick}
            >
              {(layoutMode === 'static') ? <i className="pi pi-angle-left" style={{ fontSize: '14px' }} /> : <i className="pi pi-angle-right" style={{ fontSize: '14px' }} />}
            </button>
          </div>

          <ScrollPanel
            ref={(el) => { (this.layoutMenuScroller = el); }}
            style={{ height: '100%' }}
          >
            <div className="layout-menu-container">
              <AppMenu
                model={this.menu}
                onRootMenuItemClick={this.onRootMenuItemClick}
                layoutMode={layoutMode}
                active={menuActive}
                onMenuItemClick={this.onMenuItemClick}
              />
            </div>
          </ScrollPanel>
        </div>
        <div className="layout-main" style={{height: "100vh",display: "flex",flexDirection: "column"}}>

          <AppTopbar
            layoutMode={layoutMode}
            activeTopbarItem={activeTopbarItem}
            onTopbarItemClick={this.onTopbarItemClick}
            onMenuButtonClick={this.onMenuButtonClick}
            onTopbarMobileMenuButtonClick={this.onTopbarMobileMenuButtonClick}
            topbarMenuActive={topbarMenuActive}
          />

          <AppBreadCrumbWithRouter userName={userName} />
          <div className="layout-content" style={{display: "flex", overflow: "auto", flexWrap: "nowrap", flexDirection: "column", height: "100%"}}>
            <ProtectedRoute path="/" exact component={Dashboard} />
            <ProtectedRoute path="/metadata&statistic" component={MetaData} />
            <ProtectedRoute path="/metadata&key" component={MetaData} />
            <ProtectedRoute path="/evaluation" exact component={Evaluation} />
            <ProtectedRoute path="/evaluation/statistics" exact component={Statistics} />
            <ProtectedRoute path="/tablesstandard" component={TablesStandard} />
            <ProtectedRoute path="/tablesstandard&21311" component={TablesStandard} />
            <ProtectedRoute path="/tablesstandard&21321" component={TablesStandard} />
            <ProtectedRoute path="/tablesstandard&21341" component={TablesStandard} />
            <ProtectedRoute path="/tablesstandard&21351" component={TablesStandard} />
            <ProtectedRoute path="/tablesstandard&21352" component={TablesStandard} />
            <ProtectedRoute path="/tablesstandard&21371" component={TablesStandard} />
            <ProtectedRoute path="/standardfolders" component={StandardFolders} />
            <ProtectedRoute path="/keyfigures" component={KeyFigure} />
            <ProtectedRoute path="/keyfigures&nonmonetary" component={KeyFigure} />
            <ProtectedRoute path="/keyfigures&monetary" component={KeyFigure} />
            <ProtectedRoute path="/tablessaved" exact component={TablesSaved} />
            <ProtectedRoute path="/tablessaved&personal" exact component={TablesSaved} />
            <ProtectedRoute path="/tablessaved&shared" exact component={TablesSaved} />
            <ProtectedRoute path="/tablessaved&transfer" exact component={TablesSaved} />
            <ProtectedRoute path="/tablessaved&free" exact component={TablesSaved} />
            <ProtectedRoute path="/tablessaved/statistics" exact component={Statistics} />
            <ProtectedRoute path="/changepassword" component={ChangePassword} />
            {/* TODO please pass only necessary propt to Edit User */}
            <ProtectedRoute path="/useradmin/edituser" exact render={(props) => <UserData {...props} formType={formTypes.adminEditsUser} updateBreadcrumbNames={this.updateBreadcrumbNames.bind(this)} />} />
            <ProtectedRoute path="/useradmin" exact component={UserAdmin} />
            {/* TODO please pass only necessary propt to UserData} */}
            <ProtectedRoute path="/userdata" render={(props) => <UserData {...props} formType={formTypes.userEditsItself} updateBreadcrumbNames={this.updateBreadcrumbNames.bind(this)} />} />
            <ProtectedRoute path="/useradmin/newuser" render={(props) => <UserData {...props} formType={formTypes.adminCreatesNewUser} updateBreadcrumbNames={this.updateBreadcrumbNames.bind(this)} />} />
            <ProtectedRoute path="/referencedata" component={ReferenceData} />
            <ProtectedRoute path="/releaseobjects" component={ReleaseObjects} />
            <ProtectedRoute path="/keyfigureadmin" component={KeyFigureAdmin} />
            <ProtectedRoute path="/importpage" component={ImportPage} />
            <ProtectedRoute path="/datastock" component={Datastock} />
            <ProtectedRoute path="/requestdata" component={RequestData} />
            <ProtectedRoute path="/importlist" component={ImportList} />
            {/* <ProtectedRoute path="/empty" component={EmptyPage} /> */}
          </div>

          {mobileMenuActive && (
            <div className="layout-main-mask" />
          )}
        </div>
      </div>
    );
  }
}

// TODO delete the methods?!
/*
function changeStyleSheetUrl(id, value, prefix) {
  const element = document.getElementById(id);
  const urlTokens = element.getAttribute('href').split('/');
  urlTokens[urlTokens.length - 1] = `${prefix}-${value}.css`;
  const newURL = urlTokens.join('/');
  element.setAttribute('href', newURL);
}

function changeTheme(theme) {
  changeStyleSheetUrl('theme-css', theme, 'theme');
}

function changeLayout(theme) {
  changeStyleSheetUrl('layout-css', theme, 'layout');
}

function isTablet() {
  const width = window.innerWidth;
  return width <= 1024 && width > 640;
}
*/

export default App;
